import { useReducer } from 'react';
import { PeerProfile } from '../model/PeerProfile';
import { DiscoveringProfile } from '../model/DiscoveringProfile';

type CommunityDiscoverStore = {
  peerProfiles: DiscoveringProfile[];
  isFetched: boolean;
  error: string | null;
};

type FetchPeerProfile = {
  type: 'FETCHED_PEER_PROFILE';
  payload: PeerProfile[];
};

type ErrorFetchPeerProfile = {
  type: 'ERROR_FETCHING_PEER_PROFILE';
  payload: string;
};

type QuickConnectProfile = {
  type: 'QUICK_CONNECT_PEER_PROFILE';
  payload: string;
};

type CancelConnectProfile = {
  type: 'CANCEL_CONNECT_PEER_PROFILE';
  payload: string;
};

export type CommunityDiscoverAction =
  | FetchPeerProfile
  | ErrorFetchPeerProfile
  | QuickConnectProfile
  | CancelConnectProfile;

const DEFAULT_COMMUNITY_DISCOVER_STORE: CommunityDiscoverStore = {
  peerProfiles: [],
  isFetched: false,
  error: null,
};

export const useCommunityDiscover = () => {
  const [store, dispatch] = useReducer(
    reducer,
    DEFAULT_COMMUNITY_DISCOVER_STORE,
  );

  return {
    discoverStore: store,
    dispatch: dispatch,
  };
};

const reducer = (
  store: CommunityDiscoverStore,
  action: CommunityDiscoverAction,
) => {
  switch (action.type) {
    case 'FETCHED_PEER_PROFILE':
      return mergePeerProfiles(store, action.payload);
    case 'QUICK_CONNECT_PEER_PROFILE':
      return quickConnectPeerProfile(store, action.payload);
    case 'CANCEL_CONNECT_PEER_PROFILE':
      return cancelConnectProfile(store, action.payload);
    case 'ERROR_FETCHING_PEER_PROFILE':
      return setErrorFetchingProfile(store, action.payload);
    default:
      throw Error(`Unsupported action ${action}`);
  }
};

const mergePeerProfiles = (
  store: Readonly<CommunityDiscoverStore>,
  profiles: PeerProfile[],
): CommunityDiscoverStore => {
  return { ...store, peerProfiles: profiles, isFetched: true };
};

const quickConnectPeerProfile = (
  store: Readonly<CommunityDiscoverStore>,
  connectedProfileGuid: string,
): CommunityDiscoverStore => {
  console.log('Store: ', store);
  const newStore = { ...store };
  newStore.peerProfiles = newStore.peerProfiles.map((profile) => {
    if (profile.guid === connectedProfileGuid) {
      return { ...profile, hasConnection: true };
    }
    return profile;
  });

  console.debug('new store:', newStore);
  return newStore;
};

const cancelConnectProfile = (
  store: Readonly<CommunityDiscoverStore>,
  canceledProfileGuid: string,
) => {
  const newStore = { ...store };
  newStore.peerProfiles = newStore.peerProfiles.map((profile) => {
    if (profile.guid === canceledProfileGuid) {
      return { ...profile, hasConnection: false };
    }
    return profile;
  });

  return newStore;
};

const setErrorFetchingProfile = (
  store: Readonly<CommunityDiscoverStore>,
  error: string,
) => {
  return { ...store, error, isFetched: true };
};
